module.exports = "<span class=\"data active\">{{number}}</span>\n<h4>{{title}}</h4>\n<span class=\"text-muted\">{{description}}</span>"